import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pure-auth-layout',
    templateUrl: './pure-auth-layout.component.html',
    styleUrls: ['./pure-auth-layout.component.scss'],
    standalone: false
})
export class PureAuthLayoutComponent {
  constructor(public router: Router) {
  }
}
